/* eslint-disable no-unused-vars */
export const filterStatusObj = {
  suspended: 8,
  allButArchived: 9,
  active: 0,
  paused: 3,
};

export const campaignStatuses = {
  allStatuses: 'All Campaigns',
  allButArchived: 'All But Archived',
  active: 'Active only',
  paused: 'Paused Only',
  suspended: 'Suspended Only',
};
